import { useState, useEffect } from 'react';
import axios from 'axios';
import { Smartphone, Tv, Download } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fdt = (s) => s ? new Date(s).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

export function AppsTab({ theme }) {
  const light = theme === 'light';
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/app-installs/stats`, { withCredentials: true }).then(r => setD(r.data)).catch(() => {});
  }, []);
  const tx = light ? 'text-gray-900' : 'text-white';
  const th = light ? 'text-gray-500' : 'text-white/40';
  const card = light ? 'bg-white border-gray-200' : 'bg-white/[0.03] border-white/10';
  if (!d) return <p className={`text-xs ${th}`}>Chargement…</p>;
  const labels = d.labels || {};
  const total = Object.values(d.totals || {}).reduce((a, b) => a + b, 0);
  return (
    <div data-testid="apps-tab">
      <p className={`text-xs mb-4 ${th}`}>
        Installations détectées par la télémétrie Maya+ : chaque appareil qui ouvre une app (mobile ou TV) pour la première fois est compté ici, avec date et heure exactes. (Les stores ne fournissent pas l'heure des téléchargements — ceci mesure les <b>premières ouvertures réelles</b>.)
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        <div className={`rounded-xl border p-4 ${card}`}>
          <p className={`text-[11px] ${th}`}><Download size={11} className="inline mr-1" />Total appareils</p>
          <p className={`text-2xl font-black ${tx}`} data-testid="apps-total">{total}</p>
        </div>
        {Object.entries(labels).map(([k, label]) => (
          <div key={k} className={`rounded-xl border p-4 ${card}`}>
            <p className={`text-[11px] ${th}`}>{k.includes('app') ? <Smartphone size={11} className="inline mr-1" /> : <Tv size={11} className="inline mr-1" />}{label}</p>
            <p className={`text-2xl font-black ${tx}`}>{d.totals?.[k] || 0}</p>
          </div>
        ))}
      </div>
      <h3 className={`text-sm font-bold mb-2 ${tx}`}>Dernières premières ouvertures</h3>
      <div className={`rounded-xl border overflow-hidden ${card}`}>
        <table className="w-full text-left">
          <thead><tr className={`text-[10px] uppercase ${th}`}>
            <th className="px-3 py-2">Date & heure</th><th className="px-3 py-2">Plateforme</th><th className="px-3 py-2">Version</th><th className="px-3 py-2">Ouvertures</th>
          </tr></thead>
          <tbody data-testid="apps-recent-list">
            {(d.recent || []).map((r) => (
              <tr key={r.id} className={`text-xs border-t ${light ? 'border-gray-100' : 'border-white/5'} ${tx}`}>
                <td className="px-3 py-2">{fdt(r.first_seen)}</td>
                <td className="px-3 py-2">{labels[r.platform] || r.platform}</td>
                <td className="px-3 py-2">{r.version || '—'}</td>
                <td className="px-3 py-2">{r.launches}</td>
              </tr>
            ))}
            {(d.recent || []).length === 0 && <tr><td colSpan={4} className={`px-3 py-5 text-xs text-center ${th}`}>Aucune installation détectée pour le moment — les compteurs démarreront dès que les apps seront en ligne sur les stores.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
